<template>
  <v-col class="pa-0">
    <div v-if="!creatingUser" class="pa-6">
      <v-row>
        <v-col cols="12" md="6">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-text-field class="input" label="Search..." prepend-inner-icon="mdi-magnify" rounded v-model="search"
              style="max-width: 300px"></v-text-field>
          </v-row>
        </v-col>
        <!-- <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              style="max-width: 300px"
              class="input"
              label="Selected User Type"
              rounded
              v-model="userType"
              :items="userTypes"
              @change="
                updateSelectedType();
                getUsers();
              "
            ></v-select>
          </v-row>
        </v-col> -->
        <v-col cols="12" md="6">
          <v-row justify="center" justify-md="end">
            <VueJsonToCsv :json-data="exportData" :csv-title="'Users'" class="export-btn my-6 mx-8"></VueJsonToCsv>
          </v-row>
        </v-col>
        <!-- <v-col cols="12" md="3" class="pa-6">
          <v-row justify="center" justify-md="end" class="ma-0">
            <v-btn
              v-if="
                storeUser.userType == 'Admin' &&
                storeUser.adminType == 'Super Admin'
              "
              @click="
                selectedUser = null;
                creatingUser = true;
              "
              color="#e022d1"
              dark
              rounded
              width="240px"
              class="pink-btn"
            >
              Add New User
            </v-btn>
          </v-row>
        </v-col> -->
      </v-row>
      <v-row justify="center">
        <v-data-table no-data-text="No requests yet" style="width: 100%" :headers="headers" :items="filteredUsers" :items-per-page="10"
          class="elevation-1 ml-4 mr-8">
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon color="#4390c0" @click="
                selectedUser = item;
              creatingUser = true;
              ">mdi-eye</v-icon>
            </td>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip class="capatilize" :color="statusColor(item.status || 'pending')" dark>
              {{ item.status || "pending" }}
            </v-chip>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="creatingUser" class="pa-4">
      <HandleUser :userType="userType" :user="selectedUser" :companies="companies" :doctors="doctors"
        @userCreated="creatingUser = false" @update="getUsers()" />
    </div>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import HandleUser from "../components/HandleUser.vue";

import VueJsonToCsv from "vue-json-to-csv";

import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  getDoc,
  doc,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      headers: [
        {
          text: "First Name",
          value: "name",
        },
        { text: "Surname", value: "surname" },
        { text: "ID No.", value: "idNumber" },
        { text: "Email Address", value: "email" },
        { text: "Cell Number", value: "CellNo" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      creatingUser: false,
      userType: "Doctor",
      // userTypes: [],
      users: [],
      search: "",
      selectedUser: null,
      loading: false,
      companies: [],
      doctors: [],
    };
  },
  components: {
    HandleUser,
    VueJsonToCsv,
  },
  mounted() {
    this.getUsers();
    this.getCompanies();

    if (localStorage.getItem("ViewedUser")) {
      this.selectedUser = JSON.parse(localStorage.getItem("ViewedUser"));
      this.userType = this.selectedUser.userType;
      this.creatingUser = true;
    }
  },
  methods: {
    updateSelectedType() {
      localStorage.setItem("lastViewedUserType", this.userType);
    },
    statusColor(status) {
      switch (status) {
        case "denied":
          return "#DC143C";
        case "pending":
          return "#4390c0";
        case "approved":
          return "green";
          case "on hold":
          return "grey";
        default:
          return "grey";
      }
    },
    async getUsers() {
      try {
        let q = query(collection(db, "doctors"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.users = [];

        querySnapshot.docs.forEach((doc) => {
          let tempUser = doc.data();
          tempUser.id = doc.id;

          if (tempUser.status != "approved") {
            if (this.storeUser.userType == "Doctor") {
              if (tempUser.id == this.storeUser.id) {
                this.users.push(tempUser);
              }
            } else if (this.storeUser.userType == "Company") {
              if (tempUser.businessID == this.storeUser.id) {
                this.users.push(tempUser);
              }
            } else if (this.storeUser.userType == "Admin") {
              this.users.push(tempUser);
            }
          }
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    async getCompanies() {
      try {
        let q = query(collection(db, "businesses"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.companies = [];

        querySnapshot.docs.forEach((doc) => {
          let tempCompany = doc.data();
          tempCompany.id = doc.id;

          this.companies.push(tempCompany);
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
  },
  computed: {
    filteredUsers() {
      return this.users.filter((item) => {
        return Object.values(item).some((value) => {
          // Check if the value is not null or undefined before calling toString()
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });
      });
    },
    storeUser() {
      return this.$store.state.user;
    },
    exportData() {
      let objectList = [];
      let tempObject = {};

      if (this.filteredUsers) {
        this.filteredUsers.forEach((event) => {
          tempObject = {};

          tempObject.Name = event.name;
          tempObject.Surname = event.surname;
          tempObject.Profession = event.profession;
          tempObject.ClientPreference = event.clientPreference;
          tempObject.IDNumber = event.idNumber;
          tempObject.Email = event.email;
          tempObject.PhoneNumber = event.CellNo;
          tempObject.Address = event.address;

          objectList.push(tempObject);
        });

        return objectList;
      } else {
        return [{}];
      }
    },
  },
};
</script>

<style scoped></style>